<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class FilemoverService extends Vue {
  static updateFileMover(item) {
    const payload = {
      fiId: item.fiId,
      coreId: item.coreId,
      coreName: item.coreName,
      moverType: item.moverType,
      needsEmptyFiles: item.needsEmptyFiles,
      moverParameters: item.moverParameters,
    };

    const keys = Object.keys(item);
    const values = Object.values(item);
    for (let i = 0; i < keys.length; i += 1) {
      payload[keys[i]] = values[i];
    }

    axios.put('/api/filemover/updateFi', payload)
      .then((data) => {
      })
      .finally(() => {
        this.loading = false;
      });
  }

  static getFileMoverConfig(coreId, fiId) {
    const fileMoverConfig = axios.get(`/api/filemover/${coreId}/${fiId}`)
      .then(data => data.data);

    return fileMoverConfig;
  }

  static getAllFileMoverFiids() {
    const response = axios.get('/api/filemover/getAllFiid').then(data => data.data);
    return response;
  }
}
</script>
